import { ShimmerButton, ShimmerThumbnail } from "react-shimmer-effects";

const TableLoading = () => {
  return (
    <div className="min-h-[330px] rounded-lg bg-white shadow-lg p-3 my-5">
      <div>
        <div className="flex gap-8">
          <div className="grow">
            <ShimmerThumbnail height={40} rounded />
          </div>
          <ShimmerButton />
        </div>
        <ShimmerThumbnail className="mb-0" height={250} rounded />
        <div className="grid grid-cols-3 gap-5">
          <ShimmerThumbnail height={40} rounded />
          <div></div>
          <ShimmerThumbnail height={40} rounded />
        </div>
      </div>
    </div>
  );
};

export default TableLoading;
